var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('th',[_vm._v("Dsttest")]),_c('th',[_vm._v("Dstdate")]),_c('th',[_vm._v("Dstres")])])
}
var staticRenderFns = []

export { render, staticRenderFns }